import { Box } from "@mui/system";
import NegativeBalanceFilter from "./NegativeBalanceFilter";
import NegativeBalanceItem from "./NegativeBalanceItem";



const NegativeBalance = () => {
  return (
    <>
      <Box sx={{ px: 2 }}>
        <NegativeBalanceFilter />
        <NegativeBalanceItem/>
      </Box>
    </>
  );
};

export default NegativeBalance;
